import React from "react";

export const Tab = ({ tab, setTab }) => {
  return (
    <div className="container">
      <div className="collapse navbar-collapse" id="tab">
        <ul
          sx={{
            fontFamily: "'Cormorant Garamond', serif;",
          }}
          className="nav navbar-nav navbar-left"
        >
          <li>
            <button
              style={{
                background: "none",
                border: "none",
                color: "#ac3b61",
                fontWeight: 400,
                cursor: "pointer",
                position: "relative",
                paddingBottom: "4px",
                borderBottom:
                  tab === "all"
                    ? "2px solid transparent" // Ensures space for underline
                    : "none",
                backgroundImage:
                  tab === "all"
                    ? "linear-gradient(to right, #ac3b61 0%, #cc698b 100%)"
                    : "none",
                backgroundSize: "100% 2px",
                backgroundPosition: "bottom",
                backgroundRepeat: "no-repeat",
              }}
              checked={tab === "all"}
              onClick={() => setTab("all")}
              onMouseOver={(e) => (e.target.style.textDecoration = "none")}
              onMouseOut={(e) => (e.target.style.textDecoration = "none")}
              className="page-scroll"
            >
              All
            </button>
          </li>
          <li>
            <button
              style={{
                background: "none",
                border: "none",
                color: "#ac3b61",
                fontWeight: 400,
                cursor: "pointer",
                position: "relative",
                paddingBottom: "4px",
                borderBottom:
                  tab === "cakes"
                    ? "2px solid transparent" // Ensures space for underline
                    : "none",
                backgroundImage:
                  tab === "cakes"
                    ? "linear-gradient(to right, #ac3b61 0%, #cc698b 100%)"
                    : "none",
                backgroundSize: "100% 2px",
                backgroundPosition: "bottom",
                backgroundRepeat: "no-repeat",
              }}
              checked={tab === "cakes"}
              onClick={() => setTab("cakes")}
              onMouseOver={(e) => (e.target.style.textDecoration = "none")}
              onMouseOut={(e) => (e.target.style.textDecoration = "none")}
              className="page-scroll"
            >
              Cakes
            </button>
          </li>
          <li>
            <button
              style={{
                background: "none",
                border: "none",
                color: "#ac3b61",
                fontWeight: 400,
                cursor: "pointer",
                position: "relative",
                paddingBottom: "4px",
                borderBottom:
                  tab === "cupcakes"
                    ? "2px solid transparent" // Ensures space for underline
                    : "none",
                backgroundImage:
                  tab === "cupcakes"
                    ? "linear-gradient(to right, #ac3b61 0%, #cc698b 100%)"
                    : "none",
                backgroundSize: "100% 2px",
                backgroundPosition: "bottom",
                backgroundRepeat: "no-repeat",
              }}
              onClick={() => setTab("cupcakes")}
              onMouseOver={(e) => (e.target.style.textDecoration = "none")}
              onMouseOut={(e) => (e.target.style.textDecoration = "none")}
              className="page-scroll"
            >
              Cupcakes
            </button>
          </li>
          <li>
            <button
              style={{
                background: "none",
                border: "none",
                color: "#ac3b61",
                fontWeight: 400,
                cursor: "pointer",
                position: "relative",
                paddingBottom: "4px",
                borderBottom:
                  tab === "3d-cakes"
                    ? "2px solid transparent" // Ensures space for underline
                    : "none",
                backgroundImage:
                  tab === "3d-cakes"
                    ? "linear-gradient(to right, #ac3b61 0%, #cc698b 100%)"
                    : "none",
                backgroundSize: "100% 2px",
                backgroundPosition: "bottom",
                backgroundRepeat: "no-repeat",
              }}
              checked={tab === "3d-cakes"}
              onClick={() => setTab("3d-cakes")}
              onMouseOver={(e) => (e.target.style.textDecoration = "none")}
              onMouseOut={(e) => (e.target.style.textDecoration = "none")}
              className="page-scroll"
            >
              3D Cakes
            </button>
          </li>
          {/* <li>
            <button
              style={{
                background: "none",
                border: "none",
                color: "#ac3b61",
                fontWeight: 400,
                cursor: "pointer",
                position: "relative",
                paddingBottom: "4px",
                borderBottom:
                  tab === "desserts"
                    ? "2px solid transparent" // Ensures space for underline
                    : "none",
                backgroundImage:
                  tab === "desserts"
                    ? "linear-gradient(to right, #ac3b61 0%, #cc698b 100%)"
                    : "none",
                backgroundSize: "100% 2px",
                backgroundPosition: "bottom",
                backgroundRepeat: "no-repeat",
              }}
              checked={tab === "desserts"}
              onClick={() => setTab("desserts")}
              onMouseOver={(e) => (e.target.style.textDecoration = "none")}
              onMouseOut={(e) => (e.target.style.textDecoration = "none")}
              className="page-scroll"
            >
              Desserts
            </button>
          </li> */}
        </ul>
      </div>
    </div>
  );
};
